/* eslint-disable @angular-eslint/no-empty-lifecycle-method */
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { LanguageComponent } from '../language/language.component';
import { CurrencyComponent } from '../currency/currency.component';
import { CmsComponentData, SiteContextComponentService, SiteContextType } from '@spartacus/storefront';
import { BehaviorSubject, Subscription, map } from 'rxjs';
import { MenuMobileService } from '../../../store-front/misc/header/menu-mobile.service';
import { ModalService } from '../../../../../components/modal-list/modal-list.service';

@Component({
  selector: 'custom-cx-site-context-selector',
  templateUrl: './site-context-selector.component.html',
  styleUrl: './site-context-selector.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CustomSiteContextSelectorComponent implements OnInit, OnDestroy {
  SiteContextType = SiteContextType;
  subscription = new Subscription();

  context$ = this.componentData.data$.pipe(map((component: any) => component.context));

  modalsTitle$ = new BehaviorSubject<{ type: SiteContextType; label: string } | undefined>(undefined);

  constructor(
    private componentData: CmsComponentData<any>,
    private modalService: ModalService,
    private componentService: SiteContextComponentService,
    private menuService: MenuMobileService,
  ) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  openModalCurrency() {
    this.menuService.close();

    this.modalService.create({
      id: 'modal-currency',
      title: `
				<span class="material-symbols-outlined">
					currency_exchange
				</span>

				Currency
			`,
      width: 300,
      component: CurrencyComponent,
    });
  }

  openModalLanguage() {
    this.menuService.close();

    this.modalService.create({
      id: 'modal-language',
      title: `
				<span class="material-symbols-outlined">
					translate
				</span>

				Language
			`,
      width: 300,
      component: LanguageComponent,
    });
  }

  hasItens(context: SiteContextType) {
    return this.componentService.getItems(context).pipe(map((items: any[]) => items?.length > 1 || false));
  }
}
